import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import { getTemperatureColor } from '../../styles';
import { Incident, TEMPERATURE_THRESHOLDS } from '../../types';
import {
  centerContainerStyles,
  noDataTextStyles,
  temperatureCellContainerStyles,
  temperatureCellTextStyles,
} from './styles';

interface TemperatureCellProps {
  params: GridRenderCellParams<Incident, number>;
  theme: Theme;
}

const TemperatureCell: React.FC<TemperatureCellProps> = ({ params, theme }) => {
  const { value: displayValue } = params;

  if ((!displayValue || Number.isNaN(displayValue)) && displayValue !== 0) {
    return (
      <Box sx={centerContainerStyles}>
        <Typography sx={noDataTextStyles} color='textSecondary'>
          No data
        </Typography>
      </Box>
    );
  }

  const color = getTemperatureColor(displayValue, theme);
  const isIncident = displayValue > TEMPERATURE_THRESHOLDS.INCIDENT;

  return (
    <Box sx={temperatureCellContainerStyles(color)}>
      <Typography sx={temperatureCellTextStyles(color, isIncident)}>
        {displayValue.toFixed(1)}°C
      </Typography>
    </Box>
  );
};

TemperatureCell.displayName = 'TemperatureCell';

export default TemperatureCell;
